import * as THREE from 'three';

// Création d'un shader qui accepte une couleur uniforme
export const createOutlineShader = (color = new THREE.Color(181, 181, 195)) => {
	return new THREE.ShaderMaterial({
		uniforms: {
			outlineColor: { value: color }
		},
		vertexShader: `
            varying vec3 vNormal;
            void main() {
                vNormal = normal;
                vec4 modelViewPosition = (modelViewMatrix) * vec4(position, 1.0);
                gl_Position = projectionMatrix * modelViewPosition;
            }
        `,
		fragmentShader: `
            uniform vec3 outlineColor;
            void main() {
                gl_FragColor = vec4(outlineColor, 1.0);
            }
        `,
		side: THREE.BackSide,
	});
};

// Fonction pour créer le contour
export function createOutline(model: THREE.Object3D): THREE.Object3D {
	const outlineGroup = new THREE.Group(); // Regroupe les contours

	model.traverse((object: THREE.Object3D): void => {
		if (object instanceof THREE.Mesh) {
			// Création du contour en dupliquant le mesh avec le shader par défaut (noir)
			const outlineMaterial = createOutlineShader();
			const outlineMesh = new THREE.Mesh(object.geometry, outlineMaterial);

			outlineMesh.scale.multiplyScalar(1.02); // Ajuste l'épaisseur du contour
			outlineGroup.add(outlineMesh); // Ajoute à un groupe, pas à l'objet d'origine
		}
	});

	// Marquer ce groupe comme étant un outline pour le retrouver facilement
	outlineGroup.userData.isOutline = true;

	return outlineGroup;
}

// Fonction pour changer la couleur de l'outline
export function changeOutlineColor(outlineGroup: THREE.Object3D, color: THREE.Color): void {
	outlineGroup.traverse((object: THREE.Object3D): void => {
		if (object instanceof THREE.Mesh && object.material instanceof THREE.ShaderMaterial) {
			if (object.material.uniforms && object.material.uniforms.outlineColor) {
				object.material.uniforms.outlineColor.value = color;
			}
		}
	});
}
